import { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "atelier_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { const raw = localStorage.getItem(STORAGE_KEY); return raw ? JSON.parse(raw) : []; }
    catch { return []; }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }, [items]);

  const addItem = useCallback((painting) => {
    setItems((prev) => { if (prev.some((i) => i.painting.id === painting.id)) return prev; return [...prev, { painting }]; });
    setIsOpen(true);
  }, []);

  const removeItem = useCallback((id) => { setItems((prev) => prev.filter((i) => i.painting.id !== id)); }, []);
  const clearCart = useCallback(() => setItems([]), []);
  const isInCart = useCallback((id) => items.some((i) => i.painting.id === id), [items]);

  const subtotalUSD = items.reduce((sum, item) => {
    const price = item.painting.onSale && item.painting.salePrice ? Number(item.painting.salePrice) : Number(item.painting.price);
    return sum + price;
  }, 0);

  return (
    <CartContext.Provider value={{ items, count: items.length, isOpen, openCart: () => setIsOpen(true), closeCart: () => setIsOpen(false), addItem, removeItem, clearCart, isInCart, subtotalUSD }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used inside CartProvider");
  return ctx;
}
